import { CompanyActivityType, CompanyCardDTO } from 'types/company';

const activityLabels: Record<CompanyActivityType, string> = {
  FundingRoundStarted: 'Started a funding round',
  FundingRoundClosed: 'Closed a funding round',
  KpiUpdated: 'Updated KPIs',
  PitchDeckUpdated: 'Updated pitch deck',
  TeamUpdated: 'Updated team',
  GoalUpdated: 'Updated goals',
  CompanyProfileUpdated: 'Updated profile',
};

/** The newest of the company's latest activity and latest public post, if it has any. */
export function latestActivity(company: CompanyCardDTO): { label: string; at: DateString } | undefined {
  const activity = company.latestActivity
    ? { label: activityLabels[company.latestActivity.type], at: company.latestActivity.at }
    : undefined;
  const post = company.latestPost ? { label: 'Posted an update', at: company.latestPost.createdAt } : undefined;

  if (activity && post) {
    return new Date(post.at) > new Date(activity.at) ? post : activity;
  }
  return activity ?? post;
}
